export default {
    data() {
        return {
            price: {
                servicePrice: 100,
                recomended: 1,
                executorsQuantity: 1,
                discount: 0,
                materialsPrice: 0,
                default: 0,
            },
        }
    },
    computed: {
        recomendedFinalPrice() {
            const price = (this.price.default
          * this.price.executorsQuantity
          * this.price.recomended) + this.price.materialsPrice

            return price.toFixed(2)
        },
    },
    methods: {
        setPriceByKey(key, value) {
            this.price[key] = value
        },
    },
}
